import { ClientStoresState, ReadClientStoresActionTypes, READ_CLIENT_STORES_DATA_REQUEST, READ_CLIENT_STORES_DATA_SUCCESS, READ_CLIENT_STORES_DATA_FAILURE } from "store/reducers/types/dashboard/clientStores";

const defaultState: ClientStoresState = {
  isLoading: false,
  errorMessage: ""
};

export default function metroClients(state = defaultState, action: ReadClientStoresActionTypes): ClientStoresState {
  switch (action.type) {
    case READ_CLIENT_STORES_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_CLIENT_STORES_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_CLIENT_STORES_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
}
